import { createStore, derive } from 'store-utils';
import {
  ChartNodeType,
  RawDataItem,
} from '../components/funnel-chart/funnel-chart-types';
import { sumNodeValues } from '../components/funnel-chart/funnel-chart-utils';

const baseStore = createStore<IssuePrioritizationStoreState>(
  {
    rawData: [],
    loading: false,
    error: false,
  },
  'Issue Prioritization Store',
);

const IssuePrioritizationStore = derive(
  {
    startValueSum: get => {
      const { rawData } = get(baseStore);
      if (!rawData) {
        return undefined;
      }

      return sumNodeValues(rawData, ChartNodeType.Start);
    },
    endValueSum: get => {
      const { rawData } = get(baseStore);
      if (!rawData) {
        return undefined;
      }

      return sumNodeValues(rawData, ChartNodeType.End);
    },
  },
  { proxy: baseStore },
);

export interface IssuePrioritizationStoreState {
  rawData: RawDataItem[];
  loading: boolean;
  startValueSum?: number;
  endValueSum?: number;
  error: boolean;
}

export default IssuePrioritizationStore;
